import { FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth.js';
import { ApiError } from '../api.js';

export function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({
    email: '',
    displayName: '',
    fullName: '',
    iban: '',
    phone: '',
    pin: '',
  });
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await register(form);
      nav('/seller/upload', { replace: true });
    } catch (e) {
      if (e instanceof ApiError) {
        if (e.code === 'email_taken') setErr('That email is already registered.');
        else if (e.code === 'display_name_taken') setErr('Display name is taken.');
        else if (e.code === 'validation_error') {
          const issues = e.issues as { path: (string | number)[]; message: string }[];
          setErr(issues[0]?.message ?? 'Check the fields.');
        } else {
          setErr(e.message || 'Something went wrong.');
        }
      } else {
        setErr('Something went wrong.');
      }
      setBusy(false);
    }
  }

  const set = (k: keyof typeof form) => (e: { target: { value: string } }) =>
    setForm((f) => ({ ...f, [k]: e.target.value }));

  return (
    <div className="auth-page">
      <h1>Register</h1>
      <p className="auth-sub">Start selling chocolate in the box.</p>
      <form onSubmit={onSubmit} className="form">
        <label>
          Email<input type="email" value={form.email} onChange={set('email')} required />
        </label>
        <label>
          Display name
          <input value={form.displayName} onChange={set('displayName')} required />
        </label>
        <label>
          Full name
          <input value={form.fullName} onChange={set('fullName')} required />
        </label>
        <label>
          IBAN
          <input
            value={form.iban}
            onChange={set('iban')}
            autoCapitalize="characters"
            required
            placeholder="HU42 1177 …"
          />
        </label>
        <label>
          Phone
          <input
            type="tel"
            value={form.phone}
            onChange={set('phone')}
            required
            placeholder="+36 30 …"
          />
        </label>
        <label>
          PIN (4 digits)
          <input
            type="password"
            inputMode="numeric"
            pattern="\d{4}"
            maxLength={4}
            value={form.pin}
            onChange={(e) => setForm((f) => ({ ...f, pin: e.target.value.replace(/\D/g, '') }))}
            required
          />
        </label>
        {err && <div className="err">{err}</div>}
        <button type="submit" disabled={busy}>
          {busy ? '…' : 'Create account'}
        </button>
      </form>
      <p>
        Have an account? <Link to="/seller/login">Sign in</Link>
      </p>
    </div>
  );
}
